import styled from 'styled-components';

import { getFontStyle } from '~components/Text/helper';
import { ellipsis } from '~lib/styles/Theme/common';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 65px;
  padding: 0 16px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.gray400};
`;

export const LeftArea = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  ${ellipsis};
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 45px;
  width: 45px;
  height: 45px;
  margin-right: 12px;
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  border-radius: 2px;

  img {
    width: 38px;
  }
`;

export const CompanyInfo = styled.div`
  width: 100%;
  padding-right: 10px;
  ${ellipsis};
`;

export const CompanyName = styled.p`
  margin-bottom: 2px;
  ${getFontStyle('bold120_B3')};
  ${ellipsis};
`;

export const Address = styled.p`
  color: ${({ theme }) => theme.colors.gray700};
  ${getFontStyle('midium120_C1')};
  ${ellipsis};
`;
